import React from 'react';
import PropTypes from 'prop-types';
import { BlockFormControl } from '../../../../css';
import FormControlItem from './formControlItem';
import { useLocaleContext } from '../../../../../../../../../../context/LocaleContext';
import EN from '../../../../../../../../../../../EN.json';
import FR from '../../../../../../../../../../../FR.json';

const FormControlPanel = ({ id, formTypes, isDeleted, fetchData }) => {
  const local = useLocaleContext();

  const {
    DEFECT_MANAGEMENT: { accessControlFormsList } }
    = local === 'en-US' ? EN : FR;

  const updatedFormTypes =
    formTypes ||
    accessControlFormsList.reduce(
      (acc, current) => ({ ...acc, [current.key]: false }),
      {}
    );

  return (
    <>
      <BlockFormControl>
        {accessControlFormsList.map(itemData => (
          <FormControlItem
            data={itemData}
            id={id}
            formTypes={updatedFormTypes}
            isDeleted={isDeleted}
            fetchData={fetchData}
          />
        ))}
      </BlockFormControl>
    </>
  );
};

FormControlPanel.propTypes = {
  id: PropTypes.number.isRequired,
  formTypes: PropTypes.shape({
    disableBrp: PropTypes.bool,
    disableReferral: PropTypes.bool,
    disableWireless: PropTypes.bool,
  }).isRequired,
  isDeleted: PropTypes.bool.isRequired,
  fetchData: PropTypes.func.isRequired
};

export default FormControlPanel;
